var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoInternet = function SvgNoInternet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.75,
    d: "M11 3.05S9.123 1.123 6.051 1.123c-1.11 0-2.078.263-2.861.599M1 3.135s.297-.301.839-.671M2.28 5.236s.411-.498 1.17-.95M9.806 5.237S8.399 3.564 6.03 3.564c-.374 0-.724.042-1.048.113M3.884 6.962s.537-.58 1.215-.881M2.088.57l7.757 8.31"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.979,
    cy: 8.729,
    r: 0.702,
    fill: "#fff"
  })));
};
export default SvgNoInternet;